import React from "react";
import "../css/info-card.scss";

const InfoCard = ({ children, title, className }) => {
  return (
    <div className={`info_card ${className || ""}`}>
      {title && <span className="info_card_title">{title}</span>}
      {children}
    </div>
  );
};
export default InfoCard;
